import React from "react"
import { Helmet } from "react-helmet"
import { Container } from "reactstrap"
//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import List from "./List"
function AdvertPayment() {
  const BreadcrumbDetails = {
    breadcrumbItem: {
      label: "List",
      link: "/payment/businesses&services/list",
    },
    paths: [
      {
        label: "Payments",
        link: "/payment/businesses&services/list",
      },
      {
        label: "Businesses & Services",
        link: "/payment/businesses&services/list",
      },
    ],
  }

  return (
    <React.Fragment>
      <Helmet>
        <title>Payments Businesses & Services | Discover Equestrian</title>
      </Helmet>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs breadcrumbDetails={BreadcrumbDetails} />

          <List />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default AdvertPayment
